import * as Yup from 'yup';

export default Yup.object().shape({
  id: Yup.string().required('user required'),
  fullname: Yup.string().required('fullname required'),
  email: Yup.string().required('email required'),
  password: Yup.string(),
  role_id: Yup.string().uuid().required('role required'),
});
